import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import ContactForm from '../components/contact-form'
import Footer from '../components/footer'
import './contact-us.css'

const ContactUs = (props) => {
  return (
    <div className="contact-us-container1">
      <Helmet>
        <title>ContactUs - R.A.C.E. Consulting</title>
        <meta
          name="description"
          content="Empowering high school students to confidently own their future through college admissions, scholarships &amp; career paths with less stress, stronger family ties."
        />
        <meta property="og:title" content="ContactUs - R.A.C.E. Consulting" />
        <meta
          property="og:description"
          content="Independent consultant helping teens go from high school to their future, making college admissions, scholarships &amp; career choices clear and stress-free."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/4dd8a2a4-fe48-48cd-8cb1-f0a7df20a883/ea77a8a8-ecc2-4dba-b7bc-a9a53426c250?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://notus-pro-wndqzl.teleporthq.site/contact-us"
        />
      </Helmet>
      <div className="contact-us-container2">
        <header
          data-thq="thq-navbar"
          className="contact-us-thq-navbar-interactive-elm"
        >
          <Link to="/" className="contact-us-navlink10">
            <img
              alt="image"
              src="https://raceconsulting24.com/logo.png"
              className="contact-us-image1"
            />
          </Link>
          <Link to="/" className="contact-us-navlink11">
            <h1 className="contact-us-text10">R.A.C.E. Consulting, LLC</h1>
          </Link>
          <div
            data-thq="thq-navbar-nav"
            className="contact-us-thq-desktop-menu-elm"
          >
            <nav className="contact-us-thq-links-elm1">
              <Link to="/" className="contact-us-navlink12">
                Home
              </Link>
              <Link to="/services" className="contact-us-navlink13">
                Services
              </Link>
              <Link to="/about-us" className="contact-us-navlink14">
                About Us
              </Link>
              <Link to="/contact-us" className="contact-us-navlink15">
                Contact Us
              </Link>
            </nav>
            <div className="contact-us-container3">
              <a
                href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="contact-us-link1"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="contact-us-icon10"
                >
                  <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                target="_blank"
                rel="noreferrer noopener"
                className="contact-us-link2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="contact-us-icon12"
                >
                  <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path
                      d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path d="M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z"></path>
                    <path
                      d="m17.5 6.51l.01-.011"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                target="_blank"
                rel="noreferrer noopener"
                className="contact-us-link3"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="contact-us-icon17"
                >
                  <path
                    d="M1 2.838A1.84 1.84 0 0 1 2.838 1H21.16A1.837 1.837 0 0 1 23 2.838V21.16A1.84 1.84 0 0 1 21.161 23H2.838A1.84 1.84 0 0 1 1 21.161zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634c3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8c-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708zm-5.5 10.403h3.208V9.25H4.208zM7.875 5.812a2.063 2.063 0 1 1-4.125 0a2.063 2.063 0 0 1 4.125 0"
                    fill="currentColor"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@MelissaDecker-n6k"
                target="_blank"
                rel="noreferrer noopener"
                className="contact-us-link4"
              >
                <svg
                  height="32"
                  width="32"
                  viewBox="0 0 32 32"
                  className="contact-us-icon20"
                >
                  <path
                    fill="currentColor"
                    d="M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36 36 0 0 0 2 16a36 36 0 0 0 .59 6.74a3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36 36 0 0 0 30 16a36 36 0 0 0-.59-6.74M13.2 20.2v-8.4l7.27 4.2Z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div
            data-thq="thq-burger-menu"
            className="contact-us-thq-burger-menu-elm"
          >
            <svg viewBox="0 0 1024 1024" className="contact-us-icon19">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div
            data-thq="thq-mobile-menu"
            className="contact-us-thq-mobile-menu-elm"
          >
            <div className="contact-us-thq-nav-elm">
              <div className="contact-us-thq-top-elm">
                <span className="contact-us-text11">R.A.C.E Consulting</span>
                <div
                  data-thq="thq-close-menu"
                  className="contact-us-thq-close-menu-elm"
                >
                  <svg viewBox="0 0 1024 1024" className="contact-us-icon21">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="contact-us-thq-links-elm2">
                <Link to="/" className="contact-us-navlink16">
                  Home
                </Link>
                <Link to="/services" className="contact-us-navlink17">
                  Services
                </Link>
                <Link to="/about-us" className="contact-us-navlink18">
                  About Us
                </Link>
                <Link to="/contact-us" className="contact-us-navlink19">
                  Contact Us
                </Link>
              </nav>
              <div>
                <a
                  href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 602.2582857142856 1024"
                    className="contact-us-icon23"
                  >
                    <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="contact-us-icon25"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="contact-us-icon27"
                  >
                    <path
                      d="M9.429 8.969h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02c3.951 0 4.889 2.118 4.889 6.004V22h-4v-6.312c0-2.213-.535-3.461-1.897-3.461c-1.889 0-2.674 1.345-2.674 3.46V22h-4zM2.57 21.83h4V8.799h-4zM7.143 4.55a2.53 2.53 0 0 1-.753 1.802a2.57 2.57 0 0 1-1.82.748a2.6 2.6 0 0 1-1.818-.747A2.55 2.55 0 0 1 2 4.55c0-.677.27-1.325.753-1.803A2.58 2.58 0 0 1 4.571 2c.682 0 1.336.269 1.819.747s.753 1.126.753 1.803"
                      fill="currentColor"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@MelissaDecker-n6k"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    height="21"
                    width="21"
                    viewBox="4 -2 42 42"
                    className="contact-us-icon31"
                  >
                    <g fill="none" stroke="currentColor" strokeLinejoin="round">
                      <path
                        strokeWidth="4"
                        d="M11.064 10.414Q19.378 10 23.998 10t12.939.415a6 6 0 0 1 5.68 5.492q.381 4.55.381 8.017q0 3.508-.39 8.128a6 6 0 0 1-5.587 5.483Q29.91 38 23.998 38q-5.91 0-13.018-.465a6 6 0 0 1-5.587-5.48q-.395-4.655-.395-8.131q0-3.435.385-8.02a6 6 0 0 1 5.68-5.49Z"
                      ></path>
                      <path
                        strokeWidth="3.429"
                        d="M21 19.61v8.796a.857.857 0 0 0 1.33.715l6.597-4.36a.857.857 0 0 0 .006-1.427l-6.598-4.436a.857.857 0 0 0-1.335.711Z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div className="contact-us-thq-section3-elm">
        <div className="contact-us-container4">
          <img
            alt="image"
            src="https://raceconsulting24.com/taking_notes-1000w.jpg"
            className="contact-us-image2"
          />
          <div className="contact-us-thq-contact-elm">
            <h2 className="contact-us-text12">Let&apos;s Connect!</h2>
            <span className="contact-us-text13">
              <span>To schedule your free consultation, contact us via:</span>
              <br className="TextXL"></br>
            </span>
            <div className="contact-us-thq-email-elm">
              <h4 className="contact-us-text16">Email:</h4>
              <a
                href="mailto: raceconsulting24@gmail.com?subject="
                className="contact-us-link7"
              >
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span>raceconsulting24@gmail.com</span>
                <br className="contact-us-text19 TextXL"></br>
              </a>
            </div>
            <div className="contact-us-thq-phone-elm">
              <h4 className="contact-us-text20">Phone:</h4>
              <a href="tel:+14192971666" className="contact-us-link8">
                <span className="contact-us-text21">(419) 297-1666</span>
                <br className="TextXL"></br>
              </a>
            </div>
            <span className="contact-us-text23">
              We&apos;re here to support your family every step of the way
              starting with a simple conversation.
            </span>
          </div>
        </div>
        <div className="contact-us-container5">
          <ContactForm
            text={
              <Fragment>
                <span className="contact-us-text24">
                  {' '}
                  Fill out the form below, and I’ll be in touch to discuss how I
                  can best support your student’s goals.
                </span>
              </Fragment>
            }
            text1={
              <Fragment>
                <span className="contact-us-text25">FULL NAME *</span>
              </Fragment>
            }
            text2={
              <Fragment>
                <span className="contact-us-text26">EMAIL *</span>
              </Fragment>
            }
            text3={
              <Fragment>
                <span className="contact-us-text27">MESSAGE</span>
              </Fragment>
            }
            text5={
              <Fragment>
                <span className="contact-us-text28">
                  Your message has been sent!
                </span>
              </Fragment>
            }
            button={
              <Fragment>
                <span className="contact-us-text29">SEND MESSAGE</span>
              </Fragment>
            }
            text21={
              <Fragment>
                <span className="contact-us-text30">Friend</span>
              </Fragment>
            }
            text31={
              <Fragment>
                <span className="contact-us-text31">
                  HOW DID YOU HEAR ABOUT US?
                </span>
              </Fragment>
            }
            text51={
              <Fragment>
                <span className="contact-us-text32">
                  There was an issue sending your inquiry.  Please try again
                  later.
                </span>
              </Fragment>
            }
            heading={
              <Fragment>
                <span className="contact-us-text33">
                  Have a question or ready to get started?
                </span>
              </Fragment>
            }
            text211={
              <Fragment>
                <span className="contact-us-text34">Social Media</span>
              </Fragment>
            }
            text212={
              <Fragment>
                <span className="contact-us-text35">Internet</span>
              </Fragment>
            }
          ></ContactForm>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default ContactUs
